import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { FilterGlobalResponseModel } from 'src/app/models/responses/filter-global-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreinvoiceDetailService {

  constructor(private _httpClient: HttpClient) { }

  getColumnsForDetailConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.preInvoiceDetail.GetColumnsForDetailConsultation}`);
  }

  getPreInvoicesDetailWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.preInvoiceDetail.GetAllPreInvoicesDetailWithPagination}`,
      filters, { params: params }
    );
  }

  exportDetailConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.preInvoiceDetail.ExportDetailConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

}
